import { Routes } from '@/constants/routes'
import { TimelineItem } from '../ui/radial-orbital-timeline'
import { msg } from '@lingui/core/macro'

export const timelineData: TimelineItem[] = [
  {
    id: 1,
    title: msg`PIONE WALLET`,
    content: msg`A digital asset wallet enabling users to store, trade, and protect their digital assets securely, quickly, and privately.`,
    icon: '/marketing/logos/wallet.svg',
    relatedIds: [5, 6, 7, 3],
    link: Routes.Wallet
  },
  {
    id: 2,
    title: msg`PIONE FARM`,
    content: msg`A platform for tracing agricultural product origins, enhancing transparency in the supply chain and boosting trust for consumers and distributors.`,
    icon: '/marketing/logos/farm.svg',
    relatedIds: [5, 8],
    link: Routes.Farm
  },
  {
    id: 3,
    title: msg`PIONE CARE`,
    content: msg`A solution for digitizing medical records, securing personal data, and improving the efficiency of community healthcare management.`,
    icon: '/marketing/logos/care.svg',
    relatedIds: [1, 7, 8],
    link: Routes.Care
  },
  {
    id: 4,
    title: msg`PIONE HOUSE`,
    content: msg`A blockchain-based system for real estate identification and transactions, ensuring transparency, security, and fraud prevention.`,
    icon: '/marketing/logos/house.svg',
    relatedIds: [1, 6, 8],
    link: Routes.House
  },
  {
    id: 5,
    title: msg`PIONE MART`,
    content: msg`A decentralized e-commerce platform integrated with blockchain to enhance transparency and security in shopping.`,
    icon: '/marketing/logos/mart.svg',
    relatedIds: [1, 2, 6],
    link: Routes.Mart
  },
  {
    id: 6,
    title: msg`PIONE SWAP`,
    content: msg`A cross-chain asset exchange protocol enabling fast, secure, and cost-efficient transactions across multiple blockchains.`,
    icon: '/marketing/logos/swap.svg',
    relatedIds: [1, 4, 5, 7, 8],
    link: Routes.Swap
  },
  {
    id: 7,
    title: msg`PIONE AI & BOT`,
    content: msg`An intelligent AI solution supporting automated trading, profit optimization, and real-time market data analysis.`,
    icon: '/marketing/logos/ai.svg',
    relatedIds: [1, 3, 6, 8],
    link: '#'
  },
  {
    id: 8,
    title: msg`PIONE CHAIN`,
    content: msg`An eco-friendly blockchain integrated with AI, supporting global connectivity, expanding the Web3 ecosystem, and decentralized applications.`,
    icon: '/marketing/logos/chain.svg',
    relatedIds: [2, 3, 4, 6, 7],
    link: Routes.Chain
  }
]
